// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"155f5395","453":"1c4fff63","879":"5039e0cb"}[chunkId] + ".chunk.js";
};